import React from 'react';
import { Link } from 'react-router-dom'

export default (props) => (
    <div {...props}>
        <div className="head_bck" data-color="#292929" data-opacity="0.5" />

        {/*<!-- Header -->*/}
        <header className="simple_menu">

            {/*<!-- Logo -->*/}
            <div className="logo pull-left">
                <Link to="/"><b>Dream Tours & Safaris</b></Link>
            </div>

            {/*<!-- Header Buttons -->*/}
            <div className="header_btns_wrapper">

                {/*<!-- Main Menu Btn -->*/}
                <div className="main_menu">
                    <i className="ti-menu" /><i className="ti-close" />
                </div>

                {/*<!-- Sub Menu -->*/}
                <div className="sub_menu">
                    <div className="sub_cont">
                        <ul>
                            <li>
                                <a href="#" className="parents">Itinerary</a>
                                <ul className="mega_menu">
                                    <li className="mega_sub">
                                        <ul>
                                            <li>
                                                <Link to="/itinerary-overview">
                                                    Overview
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/itinerary-capetown">
                                                    Table Mountains
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/itinerary-vicfalls">
                                                    Victoria Falls
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/itinerary-okavango">
                                                    Okavango Delta
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="#" className="parents">Destination details</a>
                                <ul className="mega_menu">
                                    <li className="mega_sub">
                                        <ul>
                                            {/* <li>
                                                <Link to="/details-overview">
                                                    Overview
                                                </Link>
                                            </li> */}
                                            {/* <li>
                                                <Link to="/details-capetown">
                                                    Table Mountains
                                                </Link>
                                            </li> */}
                                            {/* <li>
                                                <Link to="/details-vicfalls">
                                                    Victoria Falls
                                                </Link>
                                            </li> */}
                                            {/* <li>
                                                <Link to="/details-okavango">
                                                    Okavango Delta
                                                </Link>
                                            </li> */}
                                            <li>
                                                <Link to="/details-seychelles">
                                                    Seychelles
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/details-mauritius">
                                                    Mauritius
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            {/* <li>
                                <Link to="/gallery-overview" className="parents">Islands</Link>
                                <ul className="mega_menu">
                                    <li className="mega_sub">
                                        <ul>
                                            <li>
                                                <Link to="/gallery-seychelles">
                                                    Seychelles
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/gallery-mauritius">
                                                    Mauritius
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li> */}
                            <li>
                                <a href="#" className="parents">Gallery</a>
                                <ul className="mega_menu">
                                    <li className="mega_sub">
                                        <ul>
                                             <li>
                                                <Link to="/gallery-mauritius">
                                                    Mauritius
                                                </Link>
                                            </li> 
                                             <li>
                                                <Link to="/gallery-capetown">
                                                    Table Mountains
                                                </Link>
                                            </li> 
                                            <li>
                                                <Link to="/gallery-vicfalls">
                                                    Victoria Falls
                                                </Link>
                                            </li>
                                             <li>
                                                <Link to="/gallery-okavango">
                                                    Okavango Delta
                                                </Link>
                                            </li> 
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            {/*<li>
                                <a href="#" className="parents no_arrow">About</a>
                            </li>*/}
                        </ul>

                    </div>
                </div>
                {/*<!-- Sub Menu End -->*/}

            </div>
            {/*<!-- Header Buttons End -->*/}

            {/*<!-- Up Arrow -->*/}
            <a href="#page" className="up_block go">
                <i className="fa fa-angle-up" />
            </a>

        </header>
        {/*<!-- Header End -->*/}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.jsx